import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  height: 100%;

  .ant-form {
    width: 100%;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  padding-bottom: 24px;
  margin-top: 8px;

  .ant-select-selector {
    min-width: 140px;
  }

  .ant-select-selection-item {
    font-weight: 600;
  }
`;

export const NumberOfQuestionsWrapper = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black7};
  font-weight: 500;
  white-space: nowrap;
`;

export const SortByWrapper = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black7};
`;

export const SelectorWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;

  .ant-select-selector {
    width: fit-content;
    padding: 4px 12px !important;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.black4};

    .ant-select-selection-item {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: ${({ theme }) => theme.colors.black7};
    }
  }
`;
